// extracted by mini-css-extract-plugin
module.exports = {"total":"_2p3FzGA","totalHeader":"_2J1UZ8x","grid":"_3BnJb4Y","label":"v5Lv7J7","value":"_7-XjI7O"};